/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Mark_ReviewedInputs */

const cs_property_ai_mark_reviewed = /** @type {(inputs: Property_Ai_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit překlad jako zkontrolovaný`)
};

const en_property_ai_mark_reviewed = /** @type {(inputs: Property_Ai_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark translation reviewed`)
};

/**
* | output |
* | --- |
* | "Mark translation reviewed" |
*
* @param {Property_Ai_Mark_ReviewedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_mark_reviewed = /** @type {((inputs?: Property_Ai_Mark_ReviewedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Mark_ReviewedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_mark_reviewed(inputs)
	return cs_property_ai_mark_reviewed(inputs)
});